import { Fragment, useEffect, useState } from "react";
import "../assets/styles/views/pv-stats.scss";
import { NavLink, useLocation, useOutletContext } from "react-router-dom";
import {
  districts_list,
  get_hierarchy_info,
  get_pv_list_from_hierarchy,
  pv_stats_export,
  rcr_area,
} from "../utils/endpoints";
import BackArrowButton from "../components/BackArrowButton";
import StatsExport from "../components/modal-contents/StatsExport";
import CheckRounded from "../assets/icons/check-rounded";
import Document from "../assets/icons/document";
import CrownRounded from "../assets/icons/crown-rounded";
import PvCardStats from "../components/PvCardStats";
import { setCookie } from "../utils/cookie";
import Profile from "../assets/icons/profile";
import PvStatsUsers from "../components/modal-contents/PvStatsUsers";

export default function PvStats() {
  const [context, setContext] = useOutletContext();
  const [districts, setDistricts] = useState();
  const [selected_district, setSelectedDistrict] = useState();
  const [cavr, setCavr] = useState();
  const [selected_cavr, setSelectedCavr] = useState();
  const [rcr, setRcr] = useState();
  const [selected_rcr, setSelectedRcr] = useState();
  const [pv_list, setPvList] = useState();
  const [initial_load, setInitialLoad] = useState(true);
  const [role, setRole] = useState();
  const [current_page, setCurrentPage] = useState(0);
  const [last_page, setLastPage] = useState(0);
  const [first_search, setFirstSearch] = useState(true);
  const page_size = 20;
  const location = useLocation();

  const getHierarchy = async (id) => {
    const response = await context.httpRequest(
      "get",
      rcr_area.replace("*", id),
      null,
      context.session.token
    );
    return response;
  };

  const loadDistricts = async () => {
    let response = await context.httpRequest(
      "get",
      districts_list,
      null,
      context.session.token
    );
    if (response.result) {
      if (location?.state?.doc?.pv?.pv.codiceDistrict && initial_load) {
        setFirstSearch(false);
        window.history.replaceState({}, "");
        let last_district_selected = response.data.find(
          (x) => x.codice === location.state.doc.pv.pv.codiceDistrict
        ).id;
        setSelectedDistrict(last_district_selected);
        if (!location?.state?.doc?.pv?.pv?.codiceArea) {
          setInitialLoad(false);
          setCurrentPage(location.state.doc.currentPage);
          setLastPage(location.state.doc.lastPage);
        }
      }
      return response.data;
    }
    return response;
  };

  const loadUserHierarchyInfo = async () => {
    let response = await context.httpRequest(
      "get",
      get_hierarchy_info,
      null,
      context.session.token
    );
    if (response.result) {
      return response.data;
    }
    return response;
  };

  useEffect(() => {
    if (role) {
      (async () => {
        if (
          role == "ADMIN" ||
          role == "GUEST" ||
          role == "TAS" ||
          location?.state?.doc?.pv
        ) {
          let districts = await loadDistricts();
          if (districts) {
            setDistricts(districts);
          }
        } else {
          const hierarchy_info = await loadUserHierarchyInfo();
          switch (role) {
            case "DM":
              setSelectedDistrict(hierarchy_info.id);
              break;
            case "AM":
              setSelectedCavr(hierarchy_info.id);
              break;
            case "RCR":
              setSelectedRcr(hierarchy_info.id);
              startSearch(hierarchy_info.id);
              break;
          }
        }
      })();
    }
  }, [role]);

  useEffect(() => {
    if (!!context.session) {
      setRole(context.session.profileTypeCode);
    }
  }, [context.session]);

  useEffect(() => {
    setCavr();
    setRcr();
    setSelectedCavr("");
    setSelectedRcr("");
    if (selected_district) {
      (async () => {
        const response = await getHierarchy(selected_district);
        if (response.result) {
          setCavr(response.data);
          if (location?.state?.doc?.pv?.pv?.codiceArea && initial_load) {
            let last_cavr_selected = response.data.find(
              (x) => x.codice === location.state.doc.pv.pv.codiceArea
            ).id;
            setSelectedCavr(last_cavr_selected);
            if (!location?.state?.doc?.pv?.pv?.loginRcr) {
              setInitialLoad(false);
              setCurrentPage(location.state.doc.currentPage);
              setLastPage(location.state.doc.lastPage);
            }
          }
        }
      })();
    }
  }, [selected_district]);

  useEffect(() => {
    setRcr();
    setSelectedRcr("");
    if (selected_cavr) {
      (async () => {
        const response = await getHierarchy(selected_cavr);
        if (response.result) {
          setRcr(response.data);
          if (location?.state?.doc?.pv?.pv?.loginRcr && initial_load) {
            let last_rcr_selected = response.data.find(
              (x) => x.codice === location.state.doc.pv.pv.loginRcr
            ).id;
            setSelectedRcr(last_rcr_selected);
            setInitialLoad(false);
            setCurrentPage(location.state.doc.currentPage);
            setLastPage(location.state.doc.lastPage);
          }
        }
      })();
    }
  }, [selected_cavr]);

  const startSearch = async (initial_rcr = null) => {
    setFirstSearch(false);
    let hierarchy_id = null;
    if (selected_district) hierarchy_id = selected_district;
    if (selected_cavr) hierarchy_id = selected_cavr;
    if (selected_rcr) hierarchy_id = selected_rcr;
    if (!hierarchy_id) hierarchy_id = initial_rcr;

    setContext({ loader: true });

    const response = await context.httpRequest(
      "get",
      get_pv_list_from_hierarchy +
        (hierarchy_id
          ? `?hierarchyId=${hierarchy_id}&pageSize=${page_size}&page=0`
          : ""),
      null,
      context.session.token
    );
    if (response.result) {
      setPvList(response.data.listaPV);
      setCurrentPage(0);
      setLastPage(Math.ceil(response.data?.countTotale / page_size) - 1);
    } else {
      setPvList([]);
    }
    setContext({ loader: false });
  };

  useEffect(() => {
    if (current_page !== null && !first_search) {
      let hierarchy_id = null;
      if (selected_district) hierarchy_id = selected_district;
      if (selected_cavr) hierarchy_id = selected_cavr;
      if (selected_rcr) hierarchy_id = selected_rcr;

      setContext({ loader: true });
      (async () => {
        const response = await context.httpRequest(
          "get",
          get_pv_list_from_hierarchy +
            (hierarchy_id
              ? `?hierarchyId=${hierarchy_id}&pageSize=${page_size}&page=${current_page}`
              : ""),
          null,
          context.session.token
        );
        if (response.result) {
          setPvList(response.data?.listaPV);
        }
        setContext({ loader: false });
      })();
    }
  }, [current_page, first_search]);

  const startExport = async (e) => {
    let hierarchy_id = null;
    if (selected_district) hierarchy_id = selected_district;
    if (selected_cavr) hierarchy_id = selected_cavr;
    if (selected_rcr) hierarchy_id = selected_rcr;

    let filters = {
      hierarchyId: parseInt(hierarchy_id),
      dateFrom: e.target.from_date.value || null,
      dateTo: e.target.to_date.value || null,
    };

    if (filters.dateFrom && filters.dateTo) {
      if (new Date(filters.dateFrom) > new Date(filters.dateTo)) {
        context.openMessage(
          "warning",
          "La data di inizio formazione deve essere minore di data fine!"
        );
        return;
      }
    }

    setContext({ loader: true });

    const response = await context.httpRequest(
      "post",
      pv_stats_export,
      filters,
      context.session.token
    );
    if (response.result) {
      if (response?.data) {
        const linkSource = `data:application/octet-stream;base64,${response?.data}`;
        const downloadLink = document.createElement("a");
        const fileName = `gestori-pv-pill_${new Date().toISOString()}.csv`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        document.querySelector("#close-modal-button").click();
        context.openMessage("success", "Esportazione avvenuta con successo!");
      } else {
        context.openMessage("warning", "Nessun dato da esportare.");
      }
    }
    setContext({ loader: false });
  };

  return (
    <>
      <BackArrowButton path="/" />
      <section className="pv-stats w-100 flex-md-wrap px-md-3 d-flex">
        <h1 className="pv-stats__title px-3 mt-3 mt-md-4 mb-3 text-start text-md-center">
          Informazioni e statistiche punti vendita
        </h1>
        {role && role !== "RCR" ? (
          <div className="pv-stats__filters-container text-end position-sticky p-3 mx-3 mx-md-auto border shadow-sm">
            <div className="gap-3 d-flex flex-column flex-md-row text-start">
              {role === "ADMIN" || role == "GUEST" || role == "TAS" ? (
                <div className="w-100">
                  <label>DISTRETTO</label>
                  <select
                    name="districts"
                    onChange={(e) => setSelectedDistrict(e.target.value)}
                    className="w-100"
                    value={selected_district}
                  >
                    <option value="">Seleziona..</option>
                    {districts
                      ? districts.map((item, index) => {
                          return (
                            <option value={item.id} key={index}>
                              {item.nome}
                            </option>
                          );
                        })
                      : null}
                  </select>
                </div>
              ) : null}
              {["ADMIN", "DM", "GUEST", "TAS"].includes(role) ? (
                <div className="w-100">
                  <label>CAVR</label>
                  <select
                    disabled={!!selected_district ? false : true}
                    name="cavr"
                    onChange={(e) => setSelectedCavr(e.target.value)}
                    className="w-100"
                    value={selected_cavr}
                  >
                    <option value="">Seleziona..</option>
                    {cavr
                      ? cavr.map((item, index) => {
                          return (
                            <option value={item.id} key={index}>
                              {item.type} {item.nome}
                            </option>
                          );
                        })
                      : null}
                  </select>
                </div>
              ) : null}
              <div className="w-100">
                <label>RCR</label>
                <select
                  disabled={!!selected_cavr ? false : true}
                  name="rcr"
                  onChange={(e) => setSelectedRcr(e.target.value)}
                  className="w-100"
                  value={selected_rcr}
                >
                  <option value="">Seleziona..</option>
                  {rcr
                    ? rcr.map((item, index) => {
                        return (
                          <option value={item.id} key={index}>
                            {item.rcrCognome} {item.rcrNome}
                          </option>
                        );
                      })
                    : null}
                </select>
              </div>
            </div>
            <div className="d-flex mt-3 gap-3 w-100 justify-content-end">
              {pv_list && pv_list.length > 0 ? (
                <button
                  onClick={() =>
                    context.openModal(
                      <StatsExport onConfirm={startExport} />,
                      false
                    )
                  }
                  className="q8-blue-button py-2 px-4"
                >
                  ESPORTA
                </button>
              ) : null}

              <button
                onClick={() => startSearch()}
                className="q8-blue-button py-2 px-4"
              >
                CERCA
              </button>
            </div>
          </div>
        ) : null}

        {context.device === "dk" ? (
          pv_list ? (
            pv_list.length > 0 ? (
              <div>
                {role === "RCR" ? (
                  <div className="d-flex w-100 justify-content-end">
                    <button
                      onClick={() =>
                        context.openModal(
                          <StatsExport onConfirm={startExport} />,
                          false
                        )
                      }
                      className="q8-blue-button py-2 px-4"
                    >
                      ESPORTA
                    </button>
                  </div>
                ) : null}
                <div
                  style={{
                    gridTemplateColumns:
                      "0.5fr 0.5fr 0.5fr 0.6fr 0.4fr 0.8fr 0.7fr 1.2fr 1fr",
                    gridTemplateAreas: ". . . . . . . . .",
                  }}
                  className="table mt-4"
                >
                  <>
                    <div className="table-th">Codice PV</div>
                    <div className="table-th d-flex justify-content-center">
                      Utenti
                    </div>
                    <div className="table-th">Codice classe</div>
                    <div className="table-th">DM</div>
                    <div className="table-th">CAVR</div>
                    <div className="table-th">RCR</div>
                    <div className="table-th">Tipologia di vendita</div>
                    <div className="table-th">Indirizzo</div>
                    <div className="table-th">Azioni</div>
                  </>
                  {pv_list.map((item, index) => {
                    const is_odd = index % 2;
                    const sell_type = item.pvAttributes.find(
                      (x) => x.name.toUpperCase() === "MODALITA_VENDITA"
                    ).value;
                    return (
                      <Fragment key={index}>
                        <div
                          style={{
                            background: is_odd ? "#f5f5f5" : "#ffffff",
                          }}
                        >
                          {item.pv.codicePv}
                        </div>
                        <div
                          style={{
                            background: is_odd ? "#f5f5f5" : "#ffffff",
                          }}
                        >
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              context.openModal(
                                <PvStatsUsers pv={item} />,
                                false
                              )
                            }
                            className="text-decoration-none d-flex flex-column align-items-center mx-auto"
                          >
                            <div
                              className="overflow-hidden d-flex align-items-center justify-content-center mb-1"
                              style={{ width: 24, height: 24 }}
                            >
                              <Profile size={27} color="#20419a" />
                            </div>
                            <small
                              className="text-nowrap"
                              style={{ fontSize: 11 }}
                            >
                              {item.utentiList
                                ? `${item.utentiList.length} ${
                                    item.utentiList.length === 1
                                      ? "Utente"
                                      : "Utenti"
                                  }`
                                : "0 Utenti"}
                            </small>
                          </div>
                        </div>
                        <div
                          style={{
                            background: is_odd ? "#f5f5f5" : "#ffffff",
                          }}
                        >
                          {item.pv.codClasse}
                        </div>
                        <div
                          style={{
                            background: is_odd ? "#f5f5f5" : "#ffffff",
                          }}
                        >
                          {item.pv.codiceDistrict}
                        </div>
                        <div
                          style={{
                            background: is_odd ? "#f5f5f5" : "#ffffff",
                          }}
                        >
                          {item.pv.codiceArea}
                        </div>
                        <div
                          style={{
                            background: is_odd ? "#f5f5f5" : "#ffffff",
                          }}
                        >
                          {item.pv.nomeRcr} {item.pv.cognomeRcr}
                        </div>
                        <div
                          style={{
                            background: is_odd ? "#f5f5f5" : "#ffffff",
                          }}
                        >
                          {sell_type}
                        </div>
                        <div
                          style={{
                            background: is_odd ? "#f5f5f5" : "#ffffff",
                          }}
                        >{`${item.pv.indirizzo} (${item.pv.cap}) ${item.pv.comune} (${item.pv.prov})`}</div>
                        <div
                          style={{
                            background: is_odd ? "#f5f5f5" : "#ffffff",
                          }}
                        >
                          <div className="d-flex align-items-center gap-3 w-100 justify-content-center p-2">
                            <NavLink
                              to="/check-list"
                              state={{
                                doc: {
                                  pv: item,
                                  currentPage: current_page,
                                  lastPage: last_page,
                                },
                                backlink: "/pv-stats",
                              }}
                              className="text-decoration-none d-flex flex-column align-items-center"
                            >
                              <div
                                className="overflow-hidden d-flex align-items-center justify-content-center mb-1"
                                style={{ width: 24, height: 24 }}
                              >
                                <CheckRounded size={29} color="#20419a" />
                              </div>

                              <small style={{ fontSize: 11 }}>Checklist</small>
                            </NavLink>
                            <NavLink
                              to="/documents"
                              state={{
                                doc: {
                                  pv: item,
                                  currentPage: current_page,
                                  lastPage: last_page,
                                },
                                backlink: "/pv-stats",
                              }}
                              className="text-decoration-none d-flex flex-column align-items-center"
                            >
                              <div
                                className="overflow-hidden d-flex align-items-center justify-content-center mb-1"
                                style={{ width: 24, height: 24 }}
                              >
                                <Document size={24} color="#20419a" />
                              </div>
                              <small style={{ fontSize: 11 }}>Documenti</small>
                            </NavLink>
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setCookie("pv_impersonate", item.pv.codicePv);
                                window.location.href = "/";
                              }}
                              className="text-decoration-none d-flex flex-column align-items-center"
                            >
                              <div
                                className="overflow-hidden d-flex align-items-center justify-content-center mb-1"
                                style={{ width: 24, height: 24 }}
                              >
                                <CrownRounded size={22} color="#20419a" />
                              </div>
                              <small style={{ fontSize: 11 }}>Imperson..</small>
                            </div>
                          </div>
                        </div>
                      </Fragment>
                    );
                  })}
                </div>
                <div className="w-100 d-flex justify-content-end gap-3 mb-5 mt-3">
                  <button
                    className="q8-blue-button py-2 px-3 mt-3"
                    disabled={current_page === 0}
                    style={{ opacity: current_page === 0 ? 0.5 : 1 }}
                    onClick={() =>
                      current_page > 0 ? setCurrentPage(current_page - 1) : null
                    }
                  >
                    Precedente
                  </button>
                  <button
                    className="q8-blue-button py-2 px-3 mt-3"
                    disabled={current_page >= last_page}
                    style={{ opacity: current_page >= last_page ? 0.5 : 1 }}
                    onClick={() =>
                      current_page < last_page
                        ? setCurrentPage(current_page + 1)
                        : null
                    }
                  >
                    Successiva
                  </button>
                </div>
              </div>
            ) : (
              <span className="pv-stats__nothing-found-message d-none d-md-block w-100 text-center mt-3 mt-md-5">
                Nessun risultato da mostrare
              </span>
            )
          ) : (
            <span className="pv-stats__nothing-found-message d-none d-md-block w-100 text-center mt-3 mt-md-5">
              Compila i filtri per proseguire
            </span>
          )
        ) : (
          <div
            className={`pv-stats__container-list mb-md-5 ${
              role !== "RCR" ? "mt-4" : "mt-md-4"
            } d-md-flex flex-md-wrap main-panel w-100 p-3 p-md-0`}
          >
            {pv_list ? (
              pv_list.length > 0 ? (
                <div className="w-100">
                  {role === "RCR" ? (
                    <div className="d-flex w-100 justify-content-end mb-3">
                      <button
                        onClick={() =>
                          context.openModal(
                            <StatsExport onConfirm={startExport} />,
                            false
                          )
                        }
                        className="q8-blue-button py-2 px-4"
                      >
                        ESPORTA
                      </button>
                    </div>
                  ) : null}
                  {pv_list.map((item, index) => {
                    return (
                      <PvCardStats
                        state={{
                          doc: {
                            pv: item,
                            currentPage: current_page,
                            lastPage: last_page,
                          },
                          backlink: "/pv-stats",
                        }}
                        context={context}
                        pv_info={item}
                        key={index}
                      />
                    );
                  })}
                  <div className="w-100 d-flex justify-content-center gap-3 mb-5">
                    <button
                      className="q8-blue-button py-2 px-3 mt-3"
                      disabled={current_page === 0}
                      style={{ opacity: current_page === 0 ? 0.5 : 1 }}
                      onClick={() =>
                        current_page > 0
                          ? setCurrentPage(current_page - 1)
                          : null
                      }
                    >
                      Precedente
                    </button>
                    <button
                      disabled={current_page >= last_page}
                      style={{ opacity: current_page >= last_page ? 0.5 : 1 }}
                      className="q8-blue-button py-2 px-3 mt-3"
                      onClick={() =>
                        current_page < last_page
                          ? setCurrentPage(current_page + 1)
                          : null
                      }
                    >
                      Successiva
                    </button>
                  </div>
                </div>
              ) : (
                <span className="pv-stats__nothing-found-message d-none d-md-block w-100 text-center mt-3 mt-md-5">
                  Nessun risultato da mostrare
                </span>
              )
            ) : (
              <span className="d-block d-md-none w-100 text-center mt-5">
                {role !== "RCR"
                  ? "Compila tutti i filtri per proseguire"
                  : "Nessun risultato da mostrare"}
              </span>
            )}
          </div>
        )}
      </section>
    </>
  );
}
